import React from 'react';
import getConfigV2 from '../../../services/configV2';
import { SwapContractType, SwapMarket } from '../../../pages/SwapPage';
import { AppLogoMark } from '../../icon/AppLogo';
import { FlashAction, TriAndAurora } from '../../icon/CrossSwapIcons';

export const configV2 = getConfigV2();

export const getDexIcon = (market: SwapMarket) => {
  if (market === 'ref') return <AppLogoMark size={14} />;
  if (market === 'tri') return <TriAndAurora></TriAndAurora>;
};

export const getDexAction = (market: SwapMarket) => {
  if (market === 'ref') return <FlashAction></FlashAction>;

  if (market === 'tri') return <FlashAction></FlashAction>;
};

// Shown in the trade route instead of the internal contract ids.
export const CONTRACT_LABELS: Partial<Record<SwapContractType, string>> = {
  Ref_Classic: 'Classic',
  Ref_DCL: 'DCL',
  Ref_CLMM: 'CLMM',
};
